function VictimUnenrollment() {
    "use strict";
    this.__type = 'VictimUnenrollment:www.veritracks.com';
    this.Id = -1;
    this.VictimUserId = -1;
    this.VictimSearchType = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = VictimUnenrollment;
}